module.exports = __webpack_public_path__ + "static/media/ob-utilities.ee16d733.svg";